import {gql} from '@apollo/client';
import {ArtworkComplete} from './ArtworkCompleteFragment';

export const CatalogPlaylistComplete = {
  catalogPlaylist: gql`
      fragment CatalogPlaylistComplete on Playlist {
          id
          name
          curatorName
          artwork {
              ...ArtworkComplete
          }
      }
      ${ArtworkComplete.artwork}
  `,
};
